import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { sherwoodConfig } from "./data";

export default function SherwoodPage() {
  return <OregonCityPageTemplate config={sherwoodConfig} />;
}